export default "__VITE_ASSET__BO69WG_b__"